import { Box, CircularProgress } from '@mui/material'

const LoadingOverlay = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size="7rem" />
    </Box>
  )
}
export default LoadingOverlay
